const colors = {
  light: {
    100: "#f9f9f7",
    200: "#f4f3ef",
    300: "#efeee8",
    400: "#eae8e0",
    500: "#e5e3d9",
  },
  lightAlpha: {
    500: "#e5e3d999",
  },
  dark: {
    100: "#292826",
    200: "#242422",
    300: "#222220",
    400: "#20201e",
    500: "#1d1d1b",
  },
  darkAlpha: {
    500: "#08080799",
  },
};

export default colors;
